export default __webpack_public_path__ + "static/media/logo_in_bg.2e6f43d9.png";